import React from 'react';
import { makeStyles } from '@fluentui/react-components';

const useStyles = makeStyles({
    errorContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
        textAlign: 'center',
        padding: '64px',
        fontSize: '18px',
        color: '#e74c3c',
    },
});

export interface AlyzeErrorMessageProps {
    message?: string;
}

export const AlyzeErrorMessage: React.FC<AlyzeErrorMessageProps> = ({ 
    message = 'An error occurred' 
}) => {
    const styles = useStyles();

    return (
        <div className={styles.errorContainer}>
            <div>{message}</div>
        </div>
    );
};
